/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty, cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { getVacationsRequestList } from "../../../apis/vacation/vacation-request";
import { getVacationsSomeList } from "../../../apis/vacation/vacations";
import DataComponent from "../../../components/DataComponent";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { TASK_STATUS_LIST } from "../../../constants/TASK";
import useForm from "../../../hooks/useForm";
import { getYearRange, dateDayofWeekFormat, diffSeconds, diffDays } from "../../../utils/date";

const VacationPlanStatus = (props) => {

  const { permission } = props

  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
  );
  const [vacationFields] = useState([
    {
      title: "이름",
      key: "employeeIdx",
      type: 'profile'
    },
    { title: "휴가유형", key: "title" },
    {
      title: "승인대기",
      key: "planUsedCount",
      onValue: (value) => {
        return <span className="font-bold">{value}</span>;
      },
    },
    {
      title: "잔여 일수",
      key: "usableCount",
      onValue: (value, field, data) => {
        return (
          <>
            <span className="font-bold">{data.usableCount}</span>
            <span className="color-gray-6"> / {data.createCount}</span>
          </>
        );
      },
    },
  ]);
  const [planFields] = useState([
    { title: "휴가유형", key: "vacationTitle" },
    {
      title: "상태",
      key: "apprStatus",
      onValue: (value, field, data) => {
        return getBadgeLabel(value, data)
      },
    },
    { title: "사용 일수", key: "useCount" },
    {
      title: "사용기간",
      key: "useTerm",
      onValue: (value, field, data) => {
        return `${dateDayofWeekFormat(data.startDate)} ~ ${dateDayofWeekFormat(
          data.endDate
        )}`;
      },
    },
  ]);
  const [vacationList, setVacationList] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [isVacationLoading, setIsVacationLoading] = useState(false)
  const [isPlanLoading, setIsPlanLoading] = useState(false)

  const [filterConfig, setFilterConfig] = useState([]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
  } = useForm(
    {
      term: String(new Date().getFullYear()),
      employee: null,
    },
  )

  const _setFilterConfig = () => {

    const filterList = [{
      title: "연도",
      type: "select",
      key: "term",
      options: {
        list: getYearRange(),
      },
    }]

    if (permission && permission.level > 2) {
      filterList.push({
          title: "대상자",
          type: 'searchEmployees',
          key: "employee",
          isSingle: true,
        })
    }

    setFilterConfig(filterList)
  }

  useEffect(() => {
    if (!isEmpty(user))
    {
      _setFilterConfig()
      submit(form);
      setSubmit(submit)
    }
  }, [user]);

  const submit = (params) => {
    const _form = cloneDeep(params)

    setIsVacationLoading(true)
    setIsPlanLoading(true)

    let targetEmployeeIdx = get(user, "employeeIdx")
    if (!isEmpty(_form.employee))
    {
      targetEmployeeIdx = _form.employee[0].idx
    }

    const vacationParams = {
      range: {
        createdTime: {
          from: `${_form.term}-01-01`,
          to: `${_form.term}-12-31`,
        },
      },
      targetEmployeeIdx,
    }

    const planParams = {
      range: {
        startDate: {
          from: `${_form.term}-01-01`,
          to: `${_form.term}-12-31`,
        },
      },
    }

    // 휴가 리스트
    getVacationsSomeList({ ...vacationParams })
      .then((res) => {
        // 사용개수가 남아있는 휴가 중 만료되지 않은 휴가현황 노출
        setVacationList(res.data.vacations.filter((v) => v.usableCount !== 0).filter((v) => diffSeconds(new Date(), v.expiredAt) >= 0));
      })
      .catch(() => { })
      .finally(() => {
        setIsVacationLoading(false)
      })

    // 휴가 요청리스트
    getVacationsRequestList({
      search: {
        employeeIdx: targetEmployeeIdx,
      },
      ...planParams,
    }).then((res) => {
      setPlanList(res.data.requests);
    }).catch(() => { })
      .finally(() => {
        setIsPlanLoading(false)
      })
  };

  const getBadgeLabel = (value, data) => {
    const target = TASK_STATUS_LIST.find(
      (vacation) => vacation.status === value
    );
    let label = ""
    let color = ""
    switch (value)
    {
      case 'approved':
        if (diffDays(data.startDate) < 0)
        {
          label = target.label
          color = target.color
        } else
        {
          if (diffDays(data.endDate) < 0)
          {
            label = "휴가중"
            color = "success"
          } else
          {
            label = "사용완료"
            color = "light"
          }
        }
        break;
      case 'pending':
        if (data.approvedApprovalCount === 0)
        {
          label = "대기중"
          color = target.color
        } else
        {
          label = `${data.approvedApprovalCount}/${data.allApprovalCount} 진행중`
          color = "warning"
        }
        break;
      default:
        label = target.label
        color = target.color
        break;
    }

    return (
      <DataComponent
        field={{
          type: "badge",
          color,
          label,
        }}
      />
    )
  }

  return (
    <>
      <Filters
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <Container className="p-0 margin-top-32" fluid>
        <Row>
          <Col sm={6}>
            <ControlTable
              title="휴가 실적 및 현황"
              isLoading={isVacationLoading}
              fields={vacationFields}
              list={vacationList}
              mt="0"
            />
          </Col>
          <Col sm={6}>
            <ControlTable
              title="휴가 내역"
              isLoading={isPlanLoading}
              fields={planFields}
              list={planList}
              mt="0"
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default VacationPlanStatus;
